import type {Asset} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'

import {AssetTypeEnum} from '../../types'
import type {AssetType} from '../../types'
import {VideoHosted} from './VideoHosted/VideoHosted'
import {VideoIframe} from './VideoIframe/VideoIframe'

type AssetVideoProps = {
  assetType?: AssetType
  optionVideo?: Asset
  optionPoster?: Asset
  autoplay?: boolean
  videoSource?: string
}

export function AssetVideo({assetType, optionVideo, optionPoster, autoplay, videoSource}: AssetVideoProps) {
  if (assetType === AssetTypeEnum.enum['Uploaded Video'] && optionVideo) {
    return <VideoHosted optionVideo={optionVideo} optionPoster={optionPoster} autoplay={autoplay} />
  }

  if (assetType === AssetTypeEnum.enum['External Video'] && videoSource) {
    return <VideoIframe videoSource={videoSource} optionPoster={optionPoster} />
  }

  return null
}
